module.exports = __webpack_public_path__ + "2d770c3902121d5d8e24da8b4e262e7f.svg";